const DefaultState = {
  loading: false,
  data: [],
  errorMsg: "",
  fishbowlSaved: false,
};

export const metafieldsReducer = (state = DefaultState, action) => {
  switch (action.type) {
    case "WRITE_METAFIELDS_LOADING":
      return {
        ...state,
        loading: true,
        errorMsg: "",
        fishbowlSaved: false,
      };
    case "WRITE_METAFIELDS_FAIL":
      return {
        ...state,
        loading: false,
        errorMsg: "Error Loading Products",
        fishbowlSaved: false,
      };
    case "WRITE_METAFIELDS_SUCCESS":
      return {
        ...state,
        loading: false,
        data: action.payload,
        errMsg: "",
        fishbowlSaved: true,
      };
    default:
      return state;
  }
};

